export enum DistributorKindEnum {
  PET_STORE = 'pet-store',
  VET_CLINIC = 'vet-clinic',
  BREEDER = 'breeder',
  TRAINER = 'trainer',
  PET_GROOMER = 'pet-groomer',
  PET_DAYCARE = 'pet-daycare',
  HOTEL = 'hotel',
  RESTAURANT = 'restaurant',
  OTHER = 'other',
}
